import axios from "axios";

export const BASE_URL = process.env.VUE_APP_API_BASE_URL;
// export const BASE_URL = "http://localhost:5000";
// export const BASE_URL = "https://ai-media-api.logicspark.in";

export const WEB_SOCKET_BASE_URL = process.env.VUE_APP_WEB_SOCKET_BASE_URL;
// export const WEB_SOCKET_BASE_URL = "wss://ai-media-api.logicspark.in";

export const API = axios.create({ baseURL: BASE_URL, timeout: 600000 });
